import type { ComponentProps } from "solid-js";
import EventAnalytics from "~/js/utilities/EventAnalytics";
import { routerConfig } from "~/solidJs/app/MainApp/models";
import { constructLinkWithParams } from "../../helpers/urlHelpres";

export enum PaymentCurrency {
	USD = "usd",
	RUB = "rub"
}

export enum SubscriptionType {
	Personal = "personal",
	Enterprise = "enterprise"
}

export enum SubscriptionLength {
	Month = "1mo",
	Year = "12mo"
}

export type Params = {
	currency?: PaymentCurrency;
	type?: SubscriptionType;
	length?: SubscriptionLength;
	promo?: string;
	source?: string;
};

export const constructPricingLink = (params: Params = {}) => {
	const url = constructLinkWithParams<Params>(`${routerConfig.pricingPage.absolute}`, params);
	return url.href;
};

export const constructBuyCreditsLink = () => {
	const url = constructLinkWithParams(`${routerConfig.accountBuyCredits.absolute}`, {});
	return url.href;
};

export const createPricingProps = (source: string) => {
	const url = constructPricingLink({ source });
	return {
		href: url,
		onClick: () => {
			EventAnalytics.subscriptionUiInteracted("upgrade", "personal", source);
		}
	} as const satisfies ComponentProps<"a">;
};

export const createBuyCreditsProps = (source: string) => {
	const url = constructBuyCreditsLink();
	return {
		href: url,
		onClick: () => {
			EventAnalytics.creditsRequested("personal", source);
		}
	} as const satisfies ComponentProps<"a">;
};

export const openPricingPage = (params: Params = {}, target = "_blank") => {
	EventAnalytics.subscriptionUiInteracted(params.source || "pricing_button_click");
	window.open(constructPricingLink(params), target);
};
